import { ProjectStage } from "../general/ProjectStage";

export enum ConstructionMilestoneId {
  PEP = 'PEP', // PEP Available
  CKC = 'CKC', // Construction Kick-Off Conducted
  soc = 'soc',
  srh = 'srh',
  bfo = 'bfo',
  ter = 'ter',
  ebop = 'ebop',
  ged = 'ged',
  fgen = 'fgen',
  com = 'com',
  // forp = 'forp', // deprecated
  cod = 'cod',
  SFI = 'SFI', // SCADA Fully Implemented
  tov = 'tov',
  sg4 = 'sg4',
  pco = 'pco'
}

export const idToStage: Record<ConstructionMilestoneId, ProjectStage> = {
  [ConstructionMilestoneId.PEP]: ProjectStage.PRE_CONSTRUCTION,
  [ConstructionMilestoneId.CKC]: ProjectStage.PRE_CONSTRUCTION,
  [ConstructionMilestoneId.soc]: ProjectStage.CONSTRUCTION,
  [ConstructionMilestoneId.srh]: ProjectStage.CONSTRUCTION,
  [ConstructionMilestoneId.bfo]: ProjectStage.CONSTRUCTION,
  [ConstructionMilestoneId.ter]: ProjectStage.CONSTRUCTION,
  [ConstructionMilestoneId.ebop]: ProjectStage.CONSTRUCTION,
  [ConstructionMilestoneId.ged]: ProjectStage.CONSTRUCTION,
  [ConstructionMilestoneId.fgen]: ProjectStage.ENERGIZATION_COD,
  [ConstructionMilestoneId.com]: ProjectStage.ENERGIZATION_COD,
  [ConstructionMilestoneId.cod]: ProjectStage.ENERGIZATION_COD,
  [ConstructionMilestoneId.SFI]: ProjectStage.POST_COD,
  [ConstructionMilestoneId.tov]: ProjectStage.POST_COD,
  [ConstructionMilestoneId.sg4]: ProjectStage.POST_COD,
  [ConstructionMilestoneId.pco]: ProjectStage.POST_COD
}
